/* eslint-disable camelcase */
import { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import ArrowButton from '../../common/button-arrow';
import {checkPermission} from '../../common/guards/can';
import t from '../../../data/translations';
import { currentUserGroup } from '../../../utils/tokenUtils';

class FurtherInformation extends Component {
  state = {
    open: true,
  };

  toggleFurtherInformation = () => {
    this.setState({ open: !this.state.open });
  };

  furtherInformationIsVisible = () => {
    if (currentUserGroup() !== 'staff') {
      return true;
    }
    return checkPermission('view', 'objective_performance');
  }

  incentiveIsBaseTarget = () => {
    const { incentive } = this.props;
    return incentive.kind === 'base_target';
  }

  render() {
    const { incentive } = this.props;
    const { open } = this.state;

    return (
      <div className="further-information">
        <div className="further-information-head">
          <Row>
            <Col lg={6}>
              {this.furtherInformationIsVisible() && (
                <div onClick={this.toggleFurtherInformation}>
                  <span className={`glyphicon glyphicon-menu-${open ? 'up' : 'down'}`} aria-hidden="true"></span>
                  <span className="further-information-title">Further information</span>
                </div>
              )}
            </Col>
            <Col lg={6}>
              {incentive.bonus_points_enabled && incentive.bonus_link && (
                <ArrowButton
                  color={incentive.locked ? 'red' : 'yellow'}
                  arrow
                  onClick={() => {
                      window.open(incentive.bonus_link, '_blank');
                  }}
                >
                  ABOUT THE INCENTIVE
                </ArrowButton>
              )}
            </Col>
          </Row>
        </div>
        {open && (
          <div className="further-information-body">
            <Row>
              <Col lg={6}>
                <div className="points-per-pack">
                  <div className="points-per-pack-pre">
                    <div>
                      {this.incentiveIsBaseTarget() ? `${t('pointsPerPack.up')} 1` : t('pointsPerPack.up')}
                    </div>
                    <strong>{incentive.points_to_target}</strong>
                  </div>
                  {this.incentiveIsBaseTarget() && (
                    <div className="points-per-pack-pre">
                      <div>
                        {t('pointsPerPack.up')} 2
                      </div>
                      <strong>{incentive.points_to_target_2}</strong>
                    </div>
                  )}
                  <div className="points-per-pack-after">
                    <div>
                      {this.incentiveIsBaseTarget() ? `${t('pointsPerPack.post')} 2` : t('pointsPerPack.over')}
                    </div>
                    <strong>{incentive.points_after_target}</strong>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="point-reward-summary">
                  <div className="points-earned">
                    <div>Points Earned</div>
                    <strong>{(incentive.points_earned && incentive.points_earned.toLocaleString('en', {useGrouping: true})) || 0}</strong>
                  </div>
                  <div className="points-awarded">
                    <div>Points Awarded</div>
                    <strong>{(incentive.points_awarded && incentive.points_awarded.toLocaleString('en', {useGrouping: true})) || 0}</strong>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

export default FurtherInformation;
